import { render, staticRenderFns } from "./ResidentProfiles.vue?vue&type=template&id=24daa078&"
import script from "./ResidentProfiles.vue?vue&type=script&lang=js&"
export * from "./ResidentProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports